export class ListInventoryClassificationEntitiesResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "entities",
            "baseName": "entities",
            "type": "Array<DataClassificationEntityOption>",
            "format": ""
        },
        {
            "name": "pagination",
            "baseName": "pagination",
            "type": "Pagination",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListInventoryClassificationEntitiesResponse.attributeTypeMap;
    }
    constructor() {
    }
}
